// @flow
import { AccommodationsActionTypes } from './constants';

const INIT_STATE = {
    accommodation: {},
    listaAccommodations: [],
    dataCharts: {},
    loading: false,
    error: false,
    formSubmited: false,
    accomodationsForExcel: []
};

type AccommodationsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { accommodation?: {} | null, listaAccommodations?: [] | null, loading?: boolean, +value ?: boolean };

const Accommodations = (state: State = INIT_STATE, action: AccommodationsAction): any => {
    // console.log(action);
    switch (action.type) {
        case AccommodationsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case AccommodationsActionTypes.GET_ACCOMMODATION: {
                    return {
                        ...state,
                        accommodation: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case AccommodationsActionTypes.LIST_ACCOMMODATIONS: {
                    return {
                        ...state,
                        listaAccommodations: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case AccommodationsActionTypes.ADD_ACCOMMODATION:
                case AccommodationsActionTypes.UPDATE_ACCOMMODATION:
                case AccommodationsActionTypes.DELETE_ACCOMMODATION: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case AccommodationsActionTypes.GET_ACCOMMODATION_CHARTS: {
                    return {
                        ...state,
                        dataCharts: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case AccommodationsActionTypes.GET_ACCOMMODATIONS_FOR_EXCEL: {
                    return {
                        ...state,
                        accomodationsForExcel: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }

                default:
                    return { ...state };
            }

        case AccommodationsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case AccommodationsActionTypes.GET_ACCOMMODATION: {
                    return {
                        ...state,
                        error: action.payload.error,
                        accommodation: {},
                        loading: false,
                    };
                }
                case AccommodationsActionTypes.LIST_ACCOMMODATIONS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaAccommodations: [],
                        loading: false,
                    };
                }
                case AccommodationsActionTypes.ADD_ACCOMMODATION:
                case AccommodationsActionTypes.UPDATE_ACCOMMODATION:
                case AccommodationsActionTypes.DELETE_ACCOMMODATION: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case AccommodationsActionTypes.GET_ACCOMMODATION_CHARTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        dataCharts: {},
                        loading: false,
                    };
                }
                case AccommodationsActionTypes.GET_ACCOMMODATIONS_FOR_EXCEL: {
                    return {
                        ...state,
                        error: action.payload.error,
                        accomodationsForExcel: [],
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }

        case AccommodationsActionTypes.GET_ACCOMMODATION:
            return { ...state, error: false, loading: true };
        case AccommodationsActionTypes.LIST_ACCOMMODATIONS:
            return { ...state, error: false, loading: true };
        case AccommodationsActionTypes.ADD_ACCOMMODATION:
            return { ...state, error: false, loading: true };
        case AccommodationsActionTypes.UPDATE_ACCOMMODATION:
            return { ...state, error: false, loading: true };
        case AccommodationsActionTypes.DELETE_ACCOMMODATION:
            return { ...state, error: false, loading: true };
        case AccommodationsActionTypes.GET_ACCOMMODATION_CHARTS:
            return { ...state, error: false, loading: true };
        case AccommodationsActionTypes.GET_ACCOMMODATIONS_FOR_EXCEL:
            return { ...state, error: false, loading: true };
        case AccommodationsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                accommodation: {},
                listaAccommodations: [],
                formSubmited: false,
                dataCharts: {},
                accomodationsForExcel: []
            };
        default:
            return { ...state };
    }
};

export default Accommodations;
